import React from 'react';
import * as styles from './research-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DEFAULT_LINES = 2;
var ResearchCard = _ref => {
  var article = _ref.article,
    _ref$useIndexHeadline = _ref.useIndexHeadline,
    useIndexHeadline = _ref$useIndexHeadline === void 0 ? false : _ref$useIndexHeadline,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$maxLines = _ref.maxLines,
    maxLines = _ref$maxLines === void 0 ? DEFAULT_LINES : _ref$maxLines,
    _ref$fixedHeight = _ref.fixedHeight,
    fixedHeight = _ref$fixedHeight === void 0 ? false : _ref$fixedHeight,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '' : _ref$target,
    _ref$rel = _ref.rel,
    rel = _ref$rel === void 0 ? '' : _ref$rel;
  var _article$image = article.image,
    image = _article$image === void 0 ? '' : _article$image,
    _article$url = article.url,
    url = _article$url === void 0 ? '' : _article$url,
    _article$excerpt = article.excerpt,
    excerpt = _article$excerpt === void 0 ? '' : _article$excerpt,
    _article$title = article.title,
    title = _article$title === void 0 ? null : _article$title,
    _article$indexHeadlin = article.indexHeadline,
    indexHeadline = _article$indexHeadlin === void 0 ? null : _article$indexHeadlin;
  var articleTitle = useIndexHeadline ? indexHeadline : title;
  return ___EmotionJSX("div", {
    css: styles.articleCard,
    className: className
  }, ___EmotionJSX("a", {
    href: url,
    css: styles.link,
    target: target,
    rel: rel,
    onClick: onClick
  }, ___EmotionJSX("div", {
    css: styles.topImageContainer
  }, ___EmotionJSX("img", {
    src: image !== null && image !== void 0 ? image : undefined,
    alt: ""
  })), ___EmotionJSX("div", {
    css: styles.content
  }, ___EmotionJSX("div", {
    css: styles.middle
  }, articleTitle && ___EmotionJSX("div", {
    css: styles.heading
  }, articleTitle), ___EmotionJSX("div", {
    css: styles.description({
      fixedHeight,
      maxLines
    })
  }, excerpt)))));
};
export default ResearchCard;